import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { $userStore } from '@lib/store';
import { cn, PaletteUtils } from '@shared/utils';
import type { ProfileResponse } from '@shared/api';
import { UserSidebarItems } from './userSidebarItems';
import { ChangePasswordModal, DeleteUserModal, EditDetailsModal, LockUserModal } from '../modals';
import { Button } from '@shared/widgets';

export interface UserSidebarProps {
  className?: string;
  user: ProfileResponse;
}

export const UserSidebar = (props: UserSidebarProps) => {
  const [showDetailsModal, setShowDetailsModal] = useState<boolean>(false);
  const [showPasswordModal, setShowPasswordModal] = useState<boolean>(false);
  const [showLockModal, setShowLockModal] = useState<boolean>(false);
  const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);

  const { t } = useTranslation('user');

  return (
    <aside className={cn('ml-[30px] w-[330px]', 'max-[1400px]:w-[280px]', PaletteUtils.isVcfcPalette && 'max-md:ml-0 max-md:w-full')}>
      {props.user.locked && (
        <div className='mb-5 text-center'>
          <Button color='primary' className='min-w-48' onClick={() => $userStore.events.unlockUser(props.user.id)}>
            {t('buttons.unlock', { ns: 'common' })}
          </Button>
        </div>
      )}
      <div
        className={cn(
          props.user.locked && [
            'relative flex items-center justify-center p-[15px]',
            'before:absolute before:left-0 before:z-[40] before:h-full before:w-full before:rounded-sm before:bg-white before:opacity-40',
          ],
        )}
      >
        <div
          className={cn(
            'w-80 bg-white p-6 dark:bg-soft-black',
            PaletteUtils.isVcfcPalette && ['rounded-xl dark:border dark:border-gray-black dark:bg-soft-black', 'max-md:w-full'],
            props.className,
          )}
        >
          <UserSidebarItems
            user={props.user}
            onShowDetailsModal={() => setShowDetailsModal(true)}
            onShowLockModal={() => setShowLockModal(true)}
            onShowPasswordModal={() => setShowPasswordModal(true)}
            onShowDeleteModal={() => setShowDeleteModal(true)}
          />
        </div>
      </div>
      <EditDetailsModal show={showDetailsModal} onClose={() => setShowDetailsModal(false)} user={props.user} />
      <ChangePasswordModal show={showPasswordModal} onClose={() => setShowPasswordModal(false)} userId={props.user.id} />
      <LockUserModal isOpen={showLockModal} onClose={() => setShowLockModal(false)} user={props.user} />
      <DeleteUserModal isOpen={showDeleteModal} onClose={() => setShowDeleteModal(false)} userId={props.user.id} />
    </aside>
  );
};
